// extracted by mini-css-extract-plugin
module.exports = {"verticalTrack":"CustomScrollbar_verticalTrack__1U9Lg","thumb":"CustomScrollbar_thumb__hjtCU"};